import { DestroyRef, inject, Injectable } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { MatPaginatorIntl } from "@angular/material/paginator";

import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class TranslatedPaginatorIntl extends MatPaginatorIntl {
  private ofLabel = "of";

  constructor(private readonly translate: TranslateService) {
    super();

    const destroyRef = inject(DestroyRef);

    this.translate.stream([
      "PAGINATOR.ITEMS_PER_PAGE",
      "PAGINATOR.NEXT_PAGE",
      "PAGINATOR.PREVIOUS_PAGE",
      "PAGINATOR.FIRST_PAGE",
      "PAGINATOR.LAST_PAGE",
      "PAGINATOR.OF"
    ]).pipe(takeUntilDestroyed(destroyRef))
      .subscribe((translations) => {
        this.itemsPerPageLabel = translations["PAGINATOR.ITEMS_PER_PAGE"] || this.itemsPerPageLabel;
        this.nextPageLabel = translations["PAGINATOR.NEXT_PAGE"] || this.nextPageLabel;
        this.previousPageLabel = translations["PAGINATOR.PREVIOUS_PAGE"] || this.previousPageLabel;
        this.firstPageLabel = translations["PAGINATOR.FIRST_PAGE"] || this.firstPageLabel;
        this.lastPageLabel = translations["PAGINATOR.LAST_PAGE"] || this.lastPageLabel;
        this.ofLabel = translations["PAGINATOR.OF"] || this.ofLabel;
        this.changes.next();
      });
  }

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (!length || !pageSize) {
      return `0 ${this.ofLabel} ${length}`;
    }

    const startIndex = page * pageSize;
    const endIndex =
      startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

    return `${startIndex + 1} – ${endIndex} ${this.ofLabel} ${length}`;
  };
}
